/**
 * Labstep
 */

import { ICONS } from 'labstep-web/constants/icons';
import type { IconProps } from 'labstep-web/core/Icon/types';
import { LogObjectClassLabels } from 'labstep-web/models/log.model';
import snakeCase from 'lodash/snakeCase';

export const getNameAndIcon = (
  objectClass: string,
): { name: string; icon: IconProps['name'] } => ({
  name: LogObjectClassLabels[
    objectClass as keyof typeof LogObjectClassLabels
  ],
  icon: ICONS[snakeCase(objectClass) as keyof typeof ICONS].primary,
});
